import { Dialog, GenericSuspense, Menu, useTranslations, useUrlParamsValueToString } from "@bsm/component";
import { useCallback } from "react";
import { Outlet, useNavigate, useParams } from "react-router-dom";

const ProjectDayOffCreateContainer = () => {

    const [TITLE, EDIT_TITLE] = useTranslations(i18n);
    const navigate = useNavigate()
    const { id } = useParams();

    const urlParamsToString = useUrlParamsValueToString()

    const handleClose = useCallback(() => {
        const params = new URLSearchParams(urlParamsToString)
        if (params.has('bulk')) {
            params.delete('bulk')
        }
        navigate(`..?${params.toString()}`)
    }, [urlParamsToString])

    const title = id ? EDIT_TITLE : TITLE
    return (
        <Dialog open title={title} onClose={handleClose}>
            <GenericSuspense>
                <Outlet />
            </GenericSuspense>
        </Dialog>
    );
};

export default ProjectDayOffCreateContainer;

const i18n = ["BSMRH.Calendar.TimeOff.Create.Dialog.Title", "BSMRH.Calendar.TimeOff.Edit.Dialog.Title"];
